'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _dec, _dec2, _class, _class2, _temp2; /* eslint-disable */

// import { compose } from 'recompose';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reactRouter = require('react-router');

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactRouterRedux = require('react-router-redux');

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _reduxAsyncConnect = require('redux-async-connect');

var _auth = require('../../redux/modules/auth');

var _alert = require('../../redux/modules/alert');

var _booking = require('../../redux/modules/booking');

var _select = require('../../redux/modules/select');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var App = (_dec = (0, _reduxAsyncConnect.asyncConnect)([{
  promise: function promise(_ref) {
    var _ref$store = _ref.store,
        dispatch = _ref$store.dispatch,
        getState = _ref$store.getState;

    var promises = [];

    if (!(0, _auth.isLoaded)(getState())) {
      promises.push(dispatch((0, _auth.load)()));
    }

    return _promise2.default.all(promises);
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user,
    userAuth: state.auth.userauth,
    loginError: state.auth.loginError,
    info: state.booking.data,
    allocate: state.booking.allocate,
    freeUpDriver: state.booking.freeUpDriver,
    setaction: state.action.setaction,
    dnf: state.action.dnf,
    showAlert: state.alert.show,
    alertModule: state.alert.module,
    attr: state.action.attr
  };
}, {
  logout: _auth.logout, hideSelect: _select.hide, pushState: _reactRouterRedux.push, showNotification: _alert.show, hideNotification: _alert.hide, freeUpDriverAction: _booking.freeUpDriver
}), _dec(_class = _dec2(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(App, _Component);

  function App() {
    var _ref2;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, App);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref2 = App.__proto__ || (0, _getPrototypeOf2.default)(App)).call.apply(_ref2, [this].concat(args))), _this), _this.handleLogout = function (event) {
      var $props = _this.props;
      event.preventDefault();
      $props.freeUpDriverAction().then($props.logout());
    }, _this.hideSelectList = function () {
      _this.props.hideSelect('');
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(App, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (!this.props.user && nextProps.user) {
        // login
        this.props.pushState('/');
      } else if (this.props.user && !nextProps.user) {
        // logout
        this.props.pushState('/login');
      } else if (!this.props.user && !nextProps.user && nextProps.userAuth) {
        // user Auth
        this.props.showNotification('userAuth');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          info = _props.info,
          allocate = _props.allocate,
          freeUpDriver = _props.freeUpDriver,
          setaction = _props.setaction,
          dnf = _props.dnf,
          user = _props.user,
          userAuth = _props.userAuth,
          loginError = _props.loginError,
          showAlert = _props.showAlert,
          alertModule = _props.alertModule;

      var styles = require('./App.scss');
      var logoImage = require('./logo.png');
      var obj = { info: info, allocate: allocate, freeUpDriver: freeUpDriver, setaction: setaction, dnf: dnf, userAuth: userAuth };
      var module = obj[alertModule];

      var errorMsg = (0, _defineProperty3.default)({}, alertModule, module ? module.error : null);
      var successMsg = {
        allocate: allocate ? allocate.status : null,
        freeUpDriver: freeUpDriver ? freeUpDriver.status : null
      };
      var loginErrorMsg = loginError ? loginError.response.text + '. ' : '';

      return _react2.default.createElement(
        'div',
        { className: styles.app },
        _react2.default.createElement('div', { className: styles.bodyLayer, onClick: this.hideSelectList }),
        _react2.default.createElement(_reactHelmet2.default, _config2.default.app.head),
        _react2.default.createElement(
          'navbar',
          { className: styles.navbar + ' container' },
          _react2.default.createElement(
            _reactRouter.IndexLink,
            { to: '/', className: styles.brandLink + ' col-md-5' },
            _react2.default.createElement(
              'div',
              { className: styles.brand + ' col-md-4' },
              _react2.default.createElement('img', { src: logoImage })
            ),
            _react2.default.createElement(
              'span',
              { className: styles.title + ' col-md-8' },
              _config2.default.app.title
            )
          ),
          user && _react2.default.createElement(
            'div',
            { className: 'col-md-7' },
            _react2.default.createElement(
              'a',
              { href: '/api-docs', className: styles.navMenu + ' col-md-3' },
              'API Docs'
            ),
            _react2.default.createElement(
              'div',
              { className: styles.user + ' col-md-9' },
              _react2.default.createElement(
                'div',
                { className: 'pull-right' },
                _react2.default.createElement('span', { className: styles.userIcon + ' fa fa-user-circle-o' }),
                _react2.default.createElement(
                  'span',
                  { className: styles.loggedInMessage },
                  _react2.default.createElement(
                    'strong',
                    null,
                    user.clientId
                  )
                ),
                _react2.default.createElement(
                  'a',
                  { href: '#', className: styles.logout, onClick: this.handleLogout },
                  'Log out'
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: styles.notify },
            showAlert && alertModule === 'userAuth' && errorMsg.userAuth && _react2.default.createElement(
              'p',
              { className: styles.error },
              userAuth.error.errors ? userAuth.error.errors : loginErrorMsg + userAuth.error.message
            ),
            showAlert && alertModule === 'info' && errorMsg.info && _react2.default.createElement(
              'p',
              { className: styles.error },
              info.error.errors ? info.error.errors : info.error.message
            ),
            showAlert && alertModule === 'allocate' && errorMsg.allocate && _react2.default.createElement(
              'p',
              { className: styles.error },
              allocate.error.errors ? allocate.error.errors : allocate.error.message
            ),
            showAlert && alertModule === 'allocate' && successMsg.allocate && _react2.default.createElement(
              'p',
              { className: styles.success },
              successMsg.allocate === 201 ? 'Driver Allocated Success' : 'Driver Not Allocated'
            ),
            showAlert && alertModule === 'freeup' && errorMsg.freeUpDriver && _react2.default.createElement(
              'p',
              { className: styles.error },
              freeUpDriver.error.errors ? freeUpDriver.error.errors : freeUpDriver.error.message
            ),
            showAlert && alertModule === 'freeup' && successMsg.freeUpDriver && _react2.default.createElement(
              'p',
              { className: styles.success },
              successMsg.freeUpDriver === 200 ? 'Free Up Driver Success' : 'Free Up Driver Failed'
            ),
            showAlert && alertModule === 'setaction' && errorMsg.setaction && _react2.default.createElement(
              'p',
              { className: styles.error },
              setaction.error.errors ? setaction.error.errors : setaction.error.message
            ),
            showAlert && alertModule === 'dnf' && errorMsg.dnf && _react2.default.createElement(
              'p',
              { className: styles.error },
              dnf.error.errors ? dnf.error.errors : dnf.error.message
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.appContent },
          this.props.children
        )
      );
    }
  }]);
  return App;
}(_react.Component), _class2.propTypes = {
  children: _propTypes2.default.object.isRequired,
  user: _propTypes2.default.object,
  userAuth: _propTypes2.default.object,
  loginError: _propTypes2.default.object,
  logout: _propTypes2.default.func,
  pushState: _propTypes2.default.func.isRequired,
  info: _propTypes2.default.object,
  allocate: _propTypes2.default.object,
  freeUpDriver: _propTypes2.default.object,
  setaction: _propTypes2.default.object,
  dnf: _propTypes2.default.object,
  showAlert: _propTypes2.default.bool,
  alertModule: _propTypes2.default.string,
  attr: _propTypes2.default.object,
  hideSelect: _propTypes2.default.func,
  showNotification: _propTypes2.default.func,
  hideNotification: _propTypes2.default.func,
  freeUpDriverAction: _propTypes2.default.func
}, _class2.contextTypes = {
  store: _propTypes2.default.object.isRequired
}, _temp2)) || _class) || _class);
exports.default = App;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/App/App.js
// module id = 867
// module chunks = 0